/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export type ApprovalBadgeMeta =
  | { kind: ApprovalBadgeKind.leftTime; expireAt: Date; icon: "clock" }
  | { kind: ApprovalBadgeKind.noDeadline; icon: undefined }
  | { kind: ApprovalBadgeKind.pending; icon: "clock" };

export enum ApprovalBadgeKind {
  leftTime = "left-time",
  noDeadline = "no-deadline",
  pending = "pending", // when left-time approval case blocked by a previous action
}
